import { create } from "zustand";
import { persist } from "zustand/middleware";

type K = Record<string, number>;

interface CartStore {
  cart: K;
  addToCart: (id: string, qty: number) => void;
  removeFromCart: (id: string) => void;
  clearCart: () => void;
  changeQty: (id: string, qty: number) => void;
}

export const useCartStore = create<CartStore>()(
  persist(
    (set) => ({
      cart: {},
      addToCart(id: string, qty: number) {
        set((state) => ({
          cart: {
            ...state.cart,
            [id]: (state.cart[id] || 0) + qty,
          },
        }));
      },
      removeFromCart(id: string) {
        set((state) => {
          const newCart = { ...state.cart };
          delete newCart[id];
          return {
            cart: newCart,
          };
        });
      },
      clearCart() {
        set(() => ({
          cart: {},
        }));
      },
      changeQty(id: string, qty: number) {
        set((state) => ({
          cart: {
            ...state.cart,
            [id]: qty,
          },
        }));
      },
    }),
    {
      name: "cart",
    }
  )
);
